export default __webpack_public_path__ + "static/media/Header-6.01fff7c8.jpg";